// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__5bzWp","top":"styles_top__3VhZ-"};